import request from 'utils/request';

const slugs = ['tag.value'];
const listSlugs = ['tags.value'];

export async function query(params) {
  return request({
    url: '/tags/',
    method: 'get',
    data: params,
    slugs: listSlugs,
  });
}

export async function queryOne(params) {
  return request({
    url: `/tags/${params.id}`,
    method: 'get',
    slugs,
  });
}

export async function create(params) {
  return request({
    url: '/tags/',
    method: 'post',
    data: params,
    slugs,
  });
}

export async function update(params) {
  return request({
    url: `/tags/${params.id}`,
    method: 'put',
    data: params,
    slugs,
  });
}

export async function remove(params) {
  return request({
    url: `/tags/${params.id}`,
    method: 'delete',
  });
}

export async function setTags(params) {
  return request({
    url: '/tags/set-tags',
    method: 'post',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/tag.js